module.exports = __webpack_public_path__ + "img/dashboard2_pl.957afa52.svg";